module.exports = __webpack_public_path__ + "img/body-bg-old.a70928dd.jpg";